export default {
      id: "oc-qcloud-usage",
      viewBox: "0 0 1402 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-qcloud",
      toString: function () {
        return this.url;
      }
    }